import { HTML5Backend } from 'react-dnd-html5-backend';

const PROSEMIRROR_PARENT_DIV_CLASS = 'ProseMirror';

export const CustomHTML5Backend = (...args) => {
  const instance = new HTML5Backend(...args);
  // It's important that we DON'T override the other methods here (at least without checking),
  // because react-dnd is not happy (will throw) if there are drops without a matching drag action.
  // It's fine the other way around (drags that don't end in a drop).
  const listeners = ['handleTopDragOver', 'handleTopDrop', 'handleTopDropCapture'];

  listeners.forEach((name) => {
    const original = instance[name];

    if (original) {
      instance[name] = (e, ...extraArgs) => {
        const proseMirrorDivs = document.getElementsByClassName(PROSEMIRROR_PARENT_DIV_CLASS);

        if (proseMirrorDivs.length > 0 && proseMirrorDivs[0].contains(e.target)) {
          // If the target (typically the drag element) is inside the prosemirror div,
          // then ignore.
          return;
        }
        original(e, ...extraArgs);
      };
    }
  });

  return instance;
};
